import TheAdminLayout from '@/Pages/Admin/Includes/TheLayOut.vue';
import HotelList from '@/Pages/Admin/Modules/Hotel/ManageHotel/Controllers/HotelList'

import { common } from '@/Pages/Admin/Modules/Common/Services/Common';



export default [
    {
        path: '/manage/hotel',
        name: 'hotel-layout',
        title: 'AdminLayout',
        component: TheAdminLayout,
        redirect: { name: 'hotel-manage' },
        children: [
            {
                path: '/',
                name: 'hotel-manage',
                component:HotelList
            },
        
           
        ],
    },

];
